export default __webpack_public_path__ + "static/media/mobile_evolution.1f0130f1.svg";